<!-- apn管理 -->
<template>
  <div class="containerWarp">
    <div class="table_top flex_wrap">
      <el-input placeholder="请输入内容" v-model="inputKey" style="width: 300px;">
        <el-button slot="append" icon="el-icon-search" @click="initPage"></el-button>
      </el-input>
      <el-button type="primary" icon="el-icon-plus" style="margin-left: 20px;" @click="addApn"></el-button>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="createTime" label="创建日期">
        <template slot-scope="scope">
          {{scope.row.createTime, 'date' | timeFormat}}
        </template>
      </el-table-column>
      <el-table-column prop="apnName" label="apnName">
      </el-table-column>
      <el-table-column prop="apnValue" label="apnValue">
      </el-table-column>
      <el-table-column prop="remark" label="备注" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="updateTime" label="更新日期">
        <template slot-scope="scope">
          {{scope.row.updateTime, 'date' | timeFormat}}
        </template>
      </el-table-column>
      <el-table-column prop="updateName" label="更新人" width="80">
      </el-table-column>
      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-edit" size="mini" @click="apnEdit(scope.row)"></el-button>
          <el-button type="danger" icon="el-icon-close" size="mini" @click="apnDeleteOr(scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="margin-top: 20px;" background layout="prev, pager, next" :total="total"
      @current-change="handleCurrentChange" :current-page.sync="currentPage">
    </el-pagination>

    <el-dialog :title="ruleForm.id? '编辑':'新增'" :visible.sync="dialogVisible" width="30%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="apn名称" prop="apnName">
          <el-input v-model="ruleForm.apnName"></el-input>
        </el-form-item>
        <el-form-item label="apn内容" prop="apnValue">
          <el-input v-model="ruleForm.apnValue"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="ruleForm.remark" type="textarea" :rows="2" placeholder="卡商信息"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { apnPage, apnDelete, apnAdd, apnUpdate } from '@/api/sim.js'
export default {
  components: {},
  props: [],
  data () {
    return {
      tableData: [],
      currentPage: 1,
      total: 0,
      inputKey: '',
      dialogVisible: false,
      ruleForm: {
        id: '',
        apnName: "",
        apnValue: "",
        remark: ""
      },
      rules: {
        apnName: { required: true, message: '请输入apnName', trigger: 'blur' },
        remark: { required: true, message: '请输入remark', trigger: 'blur' },
        apnValue: { required: true, message: '请输入apnValue', trigger: 'blur' }
      }
    };
  },
  mounted () {
    this.initPage()
  },
  methods: {
    apnEdit (row) {
      this.ruleForm = row
      this.dialogVisible = true
    },
    addApn () {
      this.ruleForm = {
        id: '',
        apnName: "",
        apnValue: "",
        remark: ""
      }
      this.dialogVisible = true
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dialogVisible = false
          if (this.ruleForm.id) {
            apnUpdate(this.ruleForm).then(res => {
              if (res.resultCode == 1001) {
                this.$message({
                  type: 'success',
                  message: '更新 [' + this.ruleForm.apnName + ']成功!'
                });
                this.initPage()
              }
            })
          }else {
            apnAdd(this.ruleForm).then(res => {
              if (res.resultCode == 1001) {
                this.$message({
                  type: 'success',
                  message: '新增 [' + this.ruleForm.apnName + ']成功!'
                });
                this.initPage()
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.initPage()
    },
    initPage () {
      apnPage({
        "keyword": this.inputKey,
        "pageNum": this.currentPage,
        "pageSize": 10
      }).then(res => {
        console.log('apn管理', res)
        if (res.resultCode == 1001) {
          this.tableData = res.resultModel.list
          this.total = res.resultModel.total
        }
      })
    },
    apnDeleteOr (row) {
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apnDelete({
          id: row.id
        }).then(res => {
          if (res.resultCode == 1001) {
            this.$message({
              type: 'success',
              message: '删除 [' + row.apnValue + ']成功!'
            });
            this.initPage()
          }
        })

      })
    }
  }
}
</script>

<style lang='scss' scoped>
</style>
